import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessConfiguration } from '../services/getBusinessConfiguration.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadBusinessConfiguration = createAsyncThunk(
  'businessConfigurations/loadBusinessConfiguration',
  async (businessId, { getState }) => {
    const selectedProject = selectSelectedProject(getState());
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const resolvedBusinessId = businessId || selectedProject?.business_id;

    if (!resolvedBusinessId) {
      return null;
    }

    const businessConfiguration = await getBusinessConfiguration(
      resolvedBusinessId,
      {
        ...activeEmployerInfo,
        activeEmployerBusinessId:
          activeEmployerInfo?.activeEmployerBusinessId || resolvedBusinessId,
      }
    );

    return {
      businessId: resolvedBusinessId,
      businessConfiguration,
    };
  }
);
